export const VITE_PAYLOAD_SERVER_URL =
  import.meta.env.VITE_PAYLOAD_SERVER_URL || ""

export const VITE_PAYLOAD_PROJECTS_ENDPOINT =
  import.meta.env.VITE_PAYLOAD_PROJECTS_ENDPOINT || ""
